import { lruMemoize } from 'reselect'
import { StringDictionary } from 'shared/types/util'

import { defaultFilterOptionIdsSelector } from '~/app/store/filterOption'
import { filterByOptionSelector } from '~/app/store/filterByOption'
import { refinementIdsByFilter } from '~/app/store/refinement'
import { filterByCategorySelector } from '~/app/store/filterByCategory'
import { REFINEMENT_DIMENSION } from 'shared/constants'
import type { State } from 'shared/types/gallery/state'

// Used to translate refinements from the URL into a format accepted by refinementIdsByFilter
export const refinementIdsToRefinementsDictionary = lruMemoize((refinements: string[], dimension: string) =>
  refinements.reduce(
    (memo, id) => ({
      ...memo,
      [id]: {
        dimension,
        value: id,
      },
    }),
    {} as StringDictionary<State.Refinement>,
  ),
)

/**
 * Returns the input list of refinements plus default values added where no refinements exist for that filter
 * @param refinementIds List of string ids
 * @param state GlobalState
 */
export const addDefaultsToRefinements = (refinementIds: string[], state: State.GlobalState): string[] => {
  const defaultRefinements = defaultFilterOptionIdsSelector(state)
  const filterByOption = filterByOptionSelector(state)
  const filterByCategory = filterByCategorySelector(state)
  const attributeRefinements = refinementIdsToRefinementsDictionary(refinementIds, REFINEMENT_DIMENSION.ATTRIBUTE)

  const refinementIdsByType = refinementIdsByFilter(attributeRefinements, filterByOption, filterByCategory)

  const defaultRefinementsToAdd = defaultRefinements.filter((defaultRefinement) => {
    const filter = filterByOption(defaultRefinement)

    return !refinementIdsByType.attributes[filter]
  })

  return defaultRefinementsToAdd.concat(refinementIds)
}
